import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnimationController,
  ModalController,
  ToastController,
  Animation,
} from "@ionic/angular";

import { Utils } from "../../../../shared/util";
import { Product } from "../../../../models/produto.model";
import { CartService } from "../../../../services/cart.service";
import { V2ItemPage } from "../v2-item/v2-item.page";
import { V2TopBarComponent } from "../v2-top-bar/v2-top-bar.component";
import { ConfigurationService } from "src/app/services/configuration.service";
import { ProductService } from "src/app/services/product.service";

@Component({
  selector: "app-card-prod",
  templateUrl: "./card-prod.component.html",
  styleUrls: ["./card-prod.component.scss"],
})
export class CardProdComponent implements OnInit, AfterViewInit {
  @ViewChild("square", { static: false }) square: ElementRef;
  @Input("prod") prod: Product;
  appmode: any;
  anim: Animation;

  constructor(
    private cart: CartService,
    private modalCtrl: ModalController,
    private topbar: V2TopBarComponent,
    private utils: Utils,
    private config: ConfigurationService,
    private animationCtrl: AnimationController,
    private productService: ProductService
  ) {
    //this.appmode = this.config.modoApp
  }

  ngAfterViewInit(): void {
    this.anim = this.animationCtrl.create("myanim");
    this.anim
      .addElement(this.square.nativeElement)
      .duration(5000)
      .iterations(Infinity)
      .keyframes([
        { offset: 0, transform: "scale(1))", opacity: "1" },
        { offset: 0.5, transform: "scale(0.9)", opacity: "1" },
        { offset: 1, transform: "scale(1)", opacity: "1" },
      ]);

    this.anim.play();
  }

  ngOnInit() {
    if (this.prod?.produtoId) {
      this.productService.getOptions(this.prod.produtoId).subscribe(options => {
        this.prod.produtoOpcaoTipos = options;
      });
    }
  }

  callItemDetails(prod: Product) {
    console.log(prod, "produtos");

    this.modalCtrl
      .create({
        component: V2ItemPage,
        componentProps: {
          prod,
        },
        cssClass: "modal-fullscreen",
      })
      .then((modal) => modal.present());
  }

  changeCartQuantity(quantity: number, prod: Product) {
    this.utils.animate("shake-horizontal", "order-button", "class", 800);
    const item = this.cart.getItemByProdId(prod.produtoId);
    if (!item) {
      this.cart.setItem({
        id: this.cart.generateNextId(),
        produto: prod,
        cartItemOpcoes: [],
        meiomeios: [],
        number: quantity,
        produtoId: prod.produtoId,
      });
      this.topbar.callOrder();
      if (this.config.modoApp != "menu") {
        let hideFooterTimeout = setTimeout(() => {
          this.utils.animate("shake-horizontal", "confirm-label", "class", 800);
        }, 1000);
      }
    } else {
      if (quantity > 0) {
        item.number = quantity;
        this.topbar.callOrder();
      } else this.cart.removeItem(item.id);
    }
  }

  getQuantity() {
    return this.cart.getItemByProdId(this.prod.produtoId)?.number || 0;
  }


 getLowestOptionPrice(prod: Product): number {
  const groups = prod.produtoOpcaoTipos ?? [];

  const mandatoryGroups = groups.filter(g => g.obrigatorio === true);
  if (mandatoryGroups.length === 0) {
    return prod.valorVenda && prod.valorVenda > 0 ? prod.valorVenda : 0;
  }

  let total = 0;

  mandatoryGroups.forEach(group => {
    const minInGroup = Math.min(
      ...group.produtoOpcaos
              .map(o => Number(o.valor))
              .filter(v => !isNaN(v)),
      Infinity        
    );
    if (minInGroup !== Infinity) total += minInGroup;
  });

  return total;
}
  

  getProductPrice(prod: Product): number {
    if (prod.valorPromocao > 0) {
      return prod.valorPromocao;
    }
  
    if (prod.valorVenda > 0) {
      return prod.valorVenda;
    }

    return this.getLowestOptionPrice(prod);
  }


  shouldShowAPartirDe(prod: Product): boolean {
    const hasPromocao = prod.valorPromocao && prod.valorPromocao > 0;
    const hasVenda = prod.valorVenda && prod.valorVenda > 0;

    return !hasPromocao && !hasVenda;
  }
}
